import isValidDate from '../../../isValidDate';

const maybeFormatDate = (str, inputType) => {
    const payload = {
        isDate: false,
        str
    };

    if (!str) {
        return payload;
    }

    if (!Boolean(inputType?.includes('date'))) {
        return payload;
    }

    const date = new Date(str);

    if (!Boolean(isValidDate(date))) {
        return str;
    }

    payload.isDate = true;

    const includeTime = Boolean(inputType?.includes('time'));

    payload.str = includeTime ? date.toLocaleString('en-GB') : date.toLocaleDateString('en-GB');

    return payload;
};

export default maybeFormatDate;
